import { useEffect, useState } from 'react';
import { fetchAllInsights, fetchInsightsByInsightType } from '../api/blog';
import { Loader } from '../components/ui/loader';

const Insights = () => {
  //const [activeTab, setActiveTab] = useState('SPOTLIGHTS');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [insights, setInsights] = useState<any[]>([]);

  //const tabs = ['SPOTLIGHTS', 'FINTECH', 'STOCK EXCHANGE', 'TECHNOLOGY'];
  
  useEffect(() => {
    const fetchData = async () => {
      //if (!activeTab) return;
      
      setIsLoading(true);
      try {
        // const data = activeTab === 'SPOTLIGHTS' 
        //   ? await fetchAllInsights() 
        //   : await fetchInsightsByInsightType(activeTab);
        const data = await fetchAllInsights();
        setInsights(data);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  //}, [activeTab]);
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  
  return (
    <div className="min-h-screen bg-white">
      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Section */}
        <section className="py-20 mx-4 sm:mx-6 lg:mx-8">
          <div className="text-center mb-16">
            <h1 className="font-serifDisplay font-normal text-[64px] leading-[100%] tracking-[0%] text-center mb-[90px]">
              Insights
            </h1>
            
            {/* Category Tabs */}
            {/* <div className="flex justify-center space-x-0 mb-16">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-3 font-medium transition-colors w-[25%] 
                    text-[13px] sm:text-sm
                    ${
                      activeTab === tab
                        ? 'bg-black text-white'
                        : 'border border-[#DEDEDE] text-gray-600 hover:bg-gray-200'
                    }`}
                >
                  {tab}
                </button>
              ))}
            </div> */}

            {/* Articles Grid */}
            <div className="grid gap-2 md:grid-cols-2 w-full">
              {insights?.map((article) => (
                <div 
                  key={article?.slug}
                  onClick={() => window.location.href = `/insights/${article?.slug}`}
                  className="relative aspect-square w-full flex flex-col items-center justify-center overflow-hidden cursor-pointer group"
                >
                  <button className="text-white z-[1] ml-auto mr-[30px] mt-[20px] font-light text-[18px] leading-[37.5px] tracking-[0px]">
                    READ MORE
                  </button>
                  <img
                    src={article?.title?.titleImage?.url}
                    alt={article?.title?.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                  />
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black opacity-40 z-0"></div>

                  <div className="relative p-8 h-full flex flex-col justify-between mr-auto">
                    <div className="mt-auto justify-items-start">
                      <p className="text-white text-sm font-medium tracking-wider">{article?.title?.insightCategory}</p>
                      <h3 className="text-3xl font-normal text-white mb-2 leading-tight text-left">
                        {article?.title?.title}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Insights;
